import SupplierResponseView from "./SupplierResponseView";
import SurveyPreview from "./SurveyPreview";
import PageNotFound from "./PageNotFound";
import SurveySubmittedPage from "./SurveySubmittedPage";
import { CheckResponsiveContextProvider } from "./Context/CheckResponsiveContext";
export const mainRoutes = [
  {
    path: "/assessment/:id",
    element: (
      <>
        <CheckResponsiveContextProvider>
          <SupplierResponseView />
        </CheckResponsiveContextProvider>
      </>
    ),
  },
  {
    path: "/assessment/:id/preview",
    element: (
      <>
        <SurveyPreview />
      </>
    ),
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  {
    path: "/assessment/:id/thankyou",

    element: (
      <>
        <CheckResponsiveContextProvider>
          <SurveySubmittedPage />
        </CheckResponsiveContextProvider>
      </>
    ),
  },
];
